import { createContext, useContext, type ReactNode } from 'react';

const StepFooterContext = createContext<ReactNode>(null);

export const StepFooterProvider = StepFooterContext.Provider;

export const StepFooter = () => useContext(StepFooterContext);
